import React from 'react'

/* Components */
import Home from '../containers/Home'

const AppRoutes = [
  {
    path:    "/:profile",
    element: <Home />,
    type:    "public",
  }
];
export default AppRoutes;